import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { Select } from "./Select";
import { useGetAllCountriesQuery } from "@/services/(my-space)/countriesApi";

interface ICountrySelectProps {
  label?: string;
  name?: string;
  value: string;
  error?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  showAIShimmer?: boolean;
}

const CountrySelect = ({
  label = "Country",
  name = "country",
  value,
  error,
  onChange,
  disabled,
  showAIShimmer = false,
}: ICountrySelectProps) => {
  const { t } = useTranslation(["common"]);
  const { data: countriesData } = useGetAllCountriesQuery({
    page: 1,
    limit: 250,
  });
  const countryOptions = useMemo(
    () =>
      countriesData?.data?.map((c) => ({
        label: c.name,
        value: c.id.toString(),
      })) || [],
    [countriesData],
  );
  return (
    <Select
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      options={countryOptions}
      error={error}
      disabled={disabled}
      placeholder={t("company:subscription.select_a_country")}
      showAIShimmer={showAIShimmer}
    />
  );
};

export default CountrySelect;
